import { useMemo } from 'react'
import { ERROR_INVITE_CODE_EXPIRED, ERROR_INVITE_CODE_EXPIRED_AND_RESENT } from '../../common/errorCodes'

export interface AuthError {
  message: string
  errorCode: number
  email?: string
}

const useInviteCodeErrors = (authErrors?: AuthError[]) => {
  return useMemo(() => {
    return {
      isInviteCodeExpired: authErrors?.some((error) => [ERROR_INVITE_CODE_EXPIRED, ERROR_INVITE_CODE_EXPIRED_AND_RESENT].includes(error.errorCode)),
      isInviteCodeResent: authErrors?.some((error) => [ERROR_INVITE_CODE_EXPIRED_AND_RESENT].includes(error.errorCode)),
    }
  }, [authErrors])
}

export default useInviteCodeErrors
